module.exports = __webpack_public_path__ + "static/img/bggreen.8f6ee542.png";